<template>
  <div class="page-container common-blue-contain focus-list bg-contain" :style="isPlayTrail ? 'display:none' : 'display:block'">
    <div class="search-container search">
      <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item :label="$t('remarks')">
          <el-input v-model="searchForm.description" :placeholder="$t('remarks')" @keyup.enter.native="handleSearch" clearable></el-input>
        </el-form-item>
        <el-form-item :label="$t('Recordtime')" class="datetime">
          <el-date-picker v-model="searchForm.logTimestampBegin" :placeholder="$t('startDate')" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" popper-class="date-picker-blue-hw" :clearable="true">
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('TO')" class="datetime">
          <el-date-picker v-model="searchForm.logTimestampEnd" :placeholder="$t('endDate')" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd 23:59:59" popper-class="date-picker-blue-hw" :clearable="true">
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('analysis')" v-has="'analyse:media:trial'" class="analy">
          <el-input v-model="searchForm.keyword" :placeholder="$t('imageRetrievalTip')" clearable @clear="clearFile" @input="clearFile">
            <i slot="prefix" class="el-input__icon el-icon-camera-solid" style="cursor: pointer;" title="点击上传查询" @click="setFile">
              <input type="file" ref="fileInputRef2" style="display: none" accept="image/png,image/jpeg,image/jpg" />
            </i></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getPageData">{{ $t('query') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <transition name="el-zoom-in-center">
      <div class="focus-container" v-show="showPage" v-loading="loading" element-loading-text="拼命加载中">
        <div class="li-container">
          <p class="li-title">{{ $t('ImportantVideos') }}</p>
          <div class="vedio-box">
            <div class="exVideo" v-if="videoShow" id="focusAmplifyVideo">
              <HistoryVideo :videoSrcArr="listData" :showBack="true" :index.sync="index" :videoShow.sync="videoShow" :showPrevNext="showPrevNext" @searchList="searchList">
              </HistoryVideo>
            </div>
            <template v-if="!videoShow">
              <div class="vedio-li" v-for="(item, index) in listData" :key="'vedio' + index">
                <div class="vedio-show tags-list" @click="playVideo(index)">
                  <div v-if="item.Played" class="played">{{ $t('Played') }}</div>
                  <img v-if="!item.preMediaUrl" :src="isDefaultTheme ? coverSrcDefault : coverSrc" class="pic" :lazy="true" alt="" style="width: 100%; height: 180px" />
                  <img v-if="item.preMediaUrl !== null && item.preMediaUrl !== ''" :src="item.preMediaUrl" class="pic" :lazy="true" alt="" style="width: 100%; height: 180px" />
                  <img src="@/icon/new-common/icon_play.png" class="play-icon" />
                  <h5 class="vedio-time">
                    {{ item.startTimestamp ? item.startTimestamp : item.logTimestamp }}
                    <span class="cancle-icon" @click.stop="cancleImportant(item, 'vedio')" :title="$t('CancelImportantMark')">
                      <img src="@/icon/icon_important.png" alt="" />
                    </span>
                    <span class="download-icon" @click.stop="downloadImg(item.path, item.name, item.mediaUrl, item)" :title="$t('download')" v-if="item.uploadFlag && item.status != 1">
                      <img src="@/icon/new-command/history/download.png" alt="" />
                    </span>
                  </h5>
                </div>
                <h5 class="vedio-label">
                  <span @click="showDialogDesc('vedio', item)">
                    <i class="el-icon-edit"></i>
                  </span>
                  <el-tooltip class="tooltip" effect="dark" :content="item.description" placement="top">
                    <span>{{ item.description }}</span>
                  </el-tooltip>
                  <span v-if="!item.description" class="no-tips">{{ $t('NoComment') }}</span>
                </h5>
              </div>
            </template>
          </div>
          <div class="vedio-pagination" v-show="!videoShow && listData.length > 0">
            <el-pagination @size-change="handleSizeChangeVedio" @current-change="handleCurrentChangeVedio" :current-page.sync="vedioPage.pageNum" :page-size="vedioPage.pageSize" layout="total, prev, pager, next" :total="vedioPage.total">
            </el-pagination>
          </div>
        </div>
        <!-- 轨迹 -->
        <div class="li-container">
          <p class="li-title">{{ $t('ImportantTrack') }}</p>
          <div class="gps-box">
            <ul>
              <li v-for="(item, index) in gpsList" :key="'gps' + index">
                <div class="gps-li">
                  <div class="gps-icon">
                    <img :src="require(isDefaultTheme ? '@/icon/focus/gps.png' : '@/icon/new-common/icon_gps.png')" />
                  </div>
                  <div class="label-box">
                    <h5>{{ item.userName }} -{{ $t('WorkPath') }}</h5>
                    <h5>{{ $t('time') }}：{{ item.startTimestamp }} {{ $t('TO') }} {{ item.endTimestamp }}</h5>
                    <p>
                      <span @click="showDialogDesc('gps', item)"><i class="el-icon-edit"></i></span>
                      <span class="description">{{ item.description }}</span>

                      <span v-if="!item.description" class="no-tips">{{ $t('NoComment') }}</span>
                    </p>
                  </div>
                  <div class="gps-btn">
                    <span class="cancle-icon" @click.stop="cancleGpsFlag(item)" :title="$t('CancelImportantMark')">
                      <img :src="require(isDefaultTheme ? '@/icon/focus/important.png' : '@/icon/icon_important.png')" alt="" />
                    </span>
                    <el-button type="primary" class="gps-play-btn" size="mini" @click="playTrail(gpsList, index)">
                      <img :src="
                          require(isDefaultTheme ? '@/icon/focus/play.png' : '@/icon/new-common/icon_play-mini.png')
                        " alt="" />
                      {{ $t('PlayTrack') }}
                    </el-button>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="vedio-pagination" v-show="gpsList.length > 0">
            <el-pagination @size-change="handleSizeChangeGps" @current-change="handleCurrentChangeGps" :current-page.sync="gpsPage.pageNum" :page-size="gpsPage.pageSize" layout="total, prev, pager, next" :total="gpsPage.total">
            </el-pagination>
          </div>
        </div>
        <!-- 重要图片 -->
        <div class="li-container">
          <p class="li-title">{{ $t('ImportantPictures') }}</p>
          <!-- 点击查看图片 但看一张图片 -->
          <div v-if="imgShow" class="preview important-img">
            <div class="img-title">
              <i class="back-icon icon16" :class="isDefaultTheme ? 'back-light' : 'back-dark'" @click="imgShow = false"></i>
              <div class="name">
                <span>
                  {{ previewMiddleImg.name }}
                </span>
                <span class="fz12 time">
                  {{ previewMiddleImg.time }}
                </span>
              </div>
            </div>
            <div class="img-preview tags-list">
              <el-image :src="previewMiddleImg.image" :preview-src-list="previewImgList"> </el-image>
            </div>
          </div>
          <div class="vedio-box" v-else>
            <div class="vedio-li" v-for="(item, index) in imageList" :key="'picture' + index">
              <div class="vedio-show tags-list">
                <el-image :src="item.mediaUrl" :title="item.location" class="pic" @click="previewMiddleImgClick(item, index, imageList)">
                </el-image>
                <h5 class="vedio-time">
                  {{ item.startTimestamp || item.uploadTimestamp }}
                  <span class="cancle-icon" @click.stop="cancleImportant(item, 'photo')" :title="$t('CancelImportantMark')">
                    <img src="@/icon/icon_important.png" alt="" />
                  </span>
                  <span class="download-icon" @click.stop="downloadImg(item.path, item.name, item.mediaUrl)" :title="$t('download')">
                    <img src="@/icon/new-command/history/download.png" alt="" />
                  </span>
                </h5>
              </div>
              <h5 class="vedio-label">
                <span @click="showDialogDesc('photo', item)"><i class="el-icon-edit"></i></span>
                <el-tooltip class="tooltip" effect="dark" :content="item.description" placement="top">
                  <span> {{ item.description }}</span>
                </el-tooltip>

                <span v-if="!item.description" class="no-tips">{{ $t('NoComment') }}</span>
              </h5>
            </div>
          </div>
          <div class="vedio-pagination" v-show="imageList.length > 0 && !imgShow">
            <el-pagination @size-change="handleSizeChangePhoto" @current-change="handleCurrentChangePhoto" :current-page.sync="photoPage.pageNum" :page-size="photoPage.pageSize" layout="total, prev, pager, next" :total="photoPage.total">
            </el-pagination>
          </div>
        </div>
      </div>
    </transition>
    <!-- 编辑/添加备注 弹窗、 -->
    <el-dialog :title="$t('edit') + titleMap[titleType] + $t('remarks')" :visible.sync="dialogEditDesc" :append-to-body="true" class="common-blue-contain" width="600px" :close-on-click-modal="false">
      <el-form :model="fromData" ref="descForm">
        <el-form-item :label="$t('remarks')" prop="description">
          <el-input type="textarea" v-model="fromData.description" autocomplete="off" :placeholder="$t('PleaseFillRemarks')" maxlength="250" show-word-limit clearable :autosize="{ minRows: 2 }"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveDesc">{{ $t('determine') }}</el-button>
        <el-button @click="closeDialogDesc">{{ $t('cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 依赖工具
import {
  getImportantVideo,
  getImportantPhoto,
  saveFileDesc,
  saveGpsDesc,
  cancleGpsFlag,
} from '@/api/new-focus/index.js'
import { listGps } from '@/api/log/log'
import store from '@/store/index'
import { isImportantFlag } from '@/api/log/video'
import { downloadPic } from '@/api/log/mediaTag'
import { warning } from '@/util/common'
import { loadFocusVideoHitory } from '@/util/focusVideo'
import { findAnalyseMediaTrial } from '@/api/imageRetrieval'
import { mapGetters } from 'vuex'
// 依赖组件
import HistoryVideo from '@/components/new-historyVideo/Index.vue'
export default {
  props: {
    trackPopupInfo: {
      type: Object,
    },
  },
  components: {
    HistoryVideo,
  },
  computed: {
    ...mapGetters(['isDefaultTheme']),
    // 计算图片预览组件的预览图数组
    previewImgList() {
      return this.imageList.map((i) => {
        return i.mediaUrl
      })
    },
    isPlayTrail() {
      return store.state.isPlayTrail
    },
  },
  data() {
    return {
      showPage: false,
      showPrevNext: true,
      previewMiddleImg: {
        name: this.$t('titleF'),
        time: '2000-01-01 00:00:00',
        image: '',
      },
      dialogEditDesc: false,
      titleType: '', // 备注类型
      fromData: {
        description: '', //备注消息
        logTimestamp: '',
        userId: '',
        type: null,
      },
      titleMap: {
        vedio: this.$t('videoS'),
        photo: this.$t('pictureS'),
        gps: this.$t('trajectory'),
      },
      vedioPage: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      gpsPage: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
      photoPage: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
      searchForm: {
        userId: '', // 用户id
        description: '', // 备注
        keyword: '', // 关键字
        appName: '', // 应用程序
        logTimestampBegin: '', // 开始日期
        logTimestampEnd: '', // 结束日期
        importantFlag: true,
        pageNum: 1,
        pageSize: 20,
      },
      videoShow: false,
      listData: [], // 重要视频集合
      index: null, // 当前选中的video index
      coverSrc: require('@/icon/monitor/coverPlaceDark.png'),
      coverSrcDefault: require('@/icon/monitor/coverPlaceLight.png'),
      vedioList: [],
      imageList: [],
      gpsList: [],
      // 是否显示 预览图片
      imgShow: false,
      // 当前预览的图片信息
      currentImgInfo: {},
      loading: false,
    }
  },
  mounted() {
    this.showPage = true
    this.getPageData()
  },
  methods: {
    // 查询数据
    getPageData() {
      if (this.searchForm.description.length > 10) {
        warning(this.$t('QueryParameterCannot'))
        return
      }
      let files = this.$refs.fileInputRef2.files
      // 关键词查询
      if (this.searchForm.keyword || (files && files.length > 0)) {
        this.showPrevNext = false
        this.findAnalyseMediaList()
        return
      }
      this.showPrevNext = true
      this.getVedioPage()
      this.getPhotoPage()
      this.getGpsPage()
    },
    getVedioPage() {
      // 重要视频
      let vedioSearch = Object.assign({}, this.searchForm, this.vedioPage)
      vedioSearch.groupActual = 1
      getImportantVideo(vedioSearch).then((res) => {
        if (res.value && res.value.list) {
          this.listData = res.value.list
          this.handleFocusVideo(res.value.list)
        }
        this.vedioPage.total = res.value ? res.value.total : 0
      })
    },
    handleFocusVideo(data) {
      let videoHistory = loadFocusVideoHitory()
      if (videoHistory.length > 0 && data.length > 0) {
        for (let item of videoHistory) {
          let index = data.findIndex((i) => {
            return i.name === item.name
          })
          console.log(index)
          if (index >= 0) {
            data[index].Played = true
          }
        }
      }
      this.listData = data
    },
    getPhotoPage() {
      // 重要图片
      let photoSearch = Object.assign({}, this.searchForm, this.photoPage)
      getImportantPhoto(photoSearch).then((res) => {
        this.imageList = res.value && res.value.list ? res.value.list : []
        this.photoPage.total = res.value ? res.value.total : 0
      })
    },
    getGpsPage() {
      // 重要轨迹
      let gpsSearch = Object.assign({}, this.searchForm, this.gpsPage)
      listGps(gpsSearch).then((res) => {
        this.gpsList = res.value && res.value.list ? res.value.list : []
        this.gpsPage.total = res.value ? res.value.total : 0
      })
    },
    // 选择图片文件
    setFile(item) {
      // 触发文件选择
      this.$refs.fileInputRef2.click()
      // 文件改变后获取文件名
      let that = this
      this.$refs.fileInputRef2.onchange = () => {
        let files = this.$refs.fileInputRef2.files
        if (files && files.length > 0) {
          that.searchForm.keyword = files[0].name
        }
      }
    },
    // 清空图片文件
    clearFile() {
      this.$refs.fileInputRef2.value = ''
    },
    // 智能分析查询图片
    findAnalyseMediaList() {
      this.gpsList = []
      this.gpsPage.total = 0
      this.listData = []
      this.vedioPage.total = 0
      this.imageList = []
      this.photoPage.total = 0
      this.loading = true
      let queryParams = new FormData()
      let files = this.$refs.fileInputRef2.files
      if (files && files.length > 0) {
        queryParams.append('featureImage', files[0])
        queryParams.append('keyword', '')
      } else {
        queryParams.append('featureImage', '')
        queryParams.append('keyword', this.searchForm.keyword)
      }
      queryParams.append('description', this.searchForm.description)
      // this.searchForm.logTimestampBegin判空
      if (this.searchForm.logTimestampBegin && this.searchForm.logTimestampBegin !== 'null') {
        queryParams.append('logTimestampBegin', this.searchForm.logTimestampBegin)
      } else {
        queryParams.append('logTimestampBegin', '')
      }
      // this.searchForm.logTimestampEnd判空
      if (this.searchForm.logTimestampEnd && this.searchForm.logTimestampEnd !== 'null') {
        queryParams.append('logTimestampEnd', this.searchForm.logTimestampEnd)
      } else {
        queryParams.append('logTimestampEnd', '')
      }
      findAnalyseMediaTrial(queryParams).then((res) => {
        if (res.state === 0) {
          this.listData = res.value.video
          this.handleFocusVideo(this.listData)
          this.vedioPage.total = this.listData.length
          this.imageList = res.value.photo
          this.photoPage.total = this.imageList.length
          this.loading = false
        }
      })
    },
    // 重要视频改变分页大小
    handleSizeChangeVedio(val) {
      this.vedioPage.pageSize = val
      this.getVedioPage()
    },
    // 重要视频切换页码
    handleCurrentChangeVedio(val) {
      this.vedioPage.pageNum = val
      this.getVedioPage()
    },
    // 重要轨迹改变分页大小
    handleSizeChangeGps(val) {
      this.gpsPage.pageSize = val
      this.getGpsPage()
    },
    // 重要轨迹分页切换页码
    handleCurrentChangeGps(val) {
      this.gpsPage.pageNum = val
      this.getGpsPage()
    },
    // 重要图片改变分页大小
    handleSizeChangePhoto(val) {
      this.photoPage.pageSize = val
      this.getPhotoPage()
    },
    // 重要图片分页切换页码
    handleCurrentChangePhoto(val) {
      this.photoPage.pageNum = val
      this.getPhotoPage()
    },
    //点击图片
    previewMiddleImgClick(item, index, imageList) {
      this.imgShow = true
      this.previewMiddleImg.image = item.mediaUrl
      this.previewMiddleImg.name = item.location
      this.previewMiddleImg.time = item.logTimestamp
    },
    // 下载图片
    downloadImg(path, name, url, media) {
      if (media && media.groupVideoList && media.groupVideoList.length > 0) {
        this.$confirm(this.$t('downLoadThisFile1') + media.groupVideoList.length + this.$t('downLoadThisFile2'), {
          confirmButtonText: this.$t('determine'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
          closeOnClickModal: false,
        }).then(async () => {
          for (let item of media.groupVideoList) {
            if (item.mediaUrl) {
              await downloadPic(item.path, item.name).then((res) => {
                this.downImg(item.name, res)
              })
            }
          }
        })
      } else if (url) {
        downloadPic(path, name).then((res) => {
          this.downImg(name, res)
        })
      }
    },
    // 下载图片
    downImg(file_name, content) {
      if (!file_name) {
        file_name = Date.parse(new Date().toString()) + ".mp4"
      } else if (file_name.indexOf('.mp4') < 0 && file_name.indexOf('.jpg') < 0) {
        file_name = file_name + ".mp4"
      }
      const csvData = new Blob([content])
      // for IE
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(csvData, file_name)
      }
      // for Non-IE (chrome, firefox etc.)
      else {
        let a = document.createElement('a')
        document.body.appendChild(a)
        a.style = 'display: none'
        const url = window.URL.createObjectURL(csvData)
        a.href = url
        a.download = file_name
        a.click()
        a.remove()
        window.URL.revokeObjectURL(url)
      }
    },
    searchList() {
      this.index = null
      this.videoShow = false
      let files = this.$refs.fileInputRef2.files
      // 关键词查询
      if (this.searchForm.keyword || (files && files.length > 0)) {
        return
      }
      this.getVedioPage()
    },
    // 根据类型更新数据
    getPageByType(type) {
      if (type === 'vedio') {
        this.getVedioPage()
      } else {
        this.getPhotoPage()
      }
    },
    // 播放视频
    playVideo(index) {
      this.videoShow = true
      this.index = index
    },
    // 播放轨迹
    playTrail(data, index) {
      store.commit('updatePlayTrail', true)
      store.commit('updateTrailData', data)
      store.commit('updateTrailIndex', index)
      this.$emit('update:currentItem', data[index])
    },
    // 打开备注编辑弹窗
    showDialogDesc(type, item) {
      this.titleType = type
      if (type === 'gps') {
        this.fromData = {
          description: item.description, //备注消息
          sidGroup: item.sidGroup,
          userId: item.userId,
        }
      } else {
        this.fromData = {
          description: item.description, //备注消息
          logTimestamp: item.logTimestamp,
          userId: item.userId,
          type: item.type,
        }
      }
      this.dialogEditDesc = true
    },
    // 关闭弹窗
    closeDialogDesc() {
      this.$refs.descForm.resetFields()
      this.dialogEditDesc = false
    },
    // 保存备注
    saveDesc() {
      if (this.titleType === 'gps') {
        saveGpsDesc(this.fromData).then((res) => {
          if (res.state === 0) {
            this.getGpsPage()
            this.$message({
              message: this.$t('SuccessfullySavedNotes'),
              type: 'success',
            })
            this.closeDialogDesc()
          }
        })
      } else {
        saveFileDesc(this.fromData).then((res) => {
          if (res.state === 0) {
            let files = this.$refs.fileInputRef2.files
            // 关键词查询
            if (this.searchForm.keyword || (files && files.length > 0)) {
              this.findAnalyseMediaList()
            } else {
              this.getPageByType(this.titleType)
            }
            this.$message({
              message: this.$t('SuccessfullySavedNotes'),
              type: 'success',
            })
            this.closeDialogDesc()
          }
        })
      }
    },
    // 图片、视频取消重要标记
    cancleImportant(item, type) {
      this.$confirm(this.$t('ConfirmCancelMark') + '?', {
        confirmButtonText: this.$t('determine'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
        closeOnClickModal: false,
      }).then(() => {
        let param = {
          importantFlag: false,
          logTimestamp: item.logTimestamp,
          type: item.type,
          userId: item.userId,
        }
        isImportantFlag(param).then((res) => {
          if (res.state === 0) {
            this.getPageByType(type)
            this.$message({
              message: this.$t('ImportantMarkRemoved'),
              type: 'success',
            })
          }
        })
      })
    },
    // 轨迹取消重要标记
    cancleGpsFlag(item) {
      this.$confirm(this.$t('ConfirmCancelMark') + '?', {
        confirmButtonText: this.$t('determine'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
        closeOnClickModal: false,
      }).then(() => {
        let param = {
          importantFlag: false,
          sidGroup: item.sidGroup,
          userId: item.userId,
        }
        cancleGpsFlag(param).then((res) => {
          if (res.state === 0) {
            this.getGpsPage()
            this.$message({
              message: this.$t('ImportantMarkRemoved'),
              type: 'success',
            })
          }
        })
      })
    },
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl';

.important-img {
  width: 96%;
  height: 100%;
  padding-top: 10px;
  padding-left: 2%;

  .img-title {
    display: flex;
    align-items: center;
    padding: 8px 0px;
    color: #333;
    border: var(--table-border);

    .name {
      width: 100%;
      display: flex;
      flex-direction: column;
      margin-left: 15px;
      color: #333;

      .time {
        color: var(--video-time-color);
      }
    }

    .back-icon {
      cursor: pointer;
      margin-left: 10px;
    }

    .back-light {
      bg-image('~@/icon/ic_back.png');
    }

    .back-dark {
      bg-image('~@/icon/ic_back_new.png');
    }
  }

  .img-preview {
    text-align: center;
    height: 84%;
    border: 1px solid #00DEFF;

    /deep/ .el-image__inner {
      max-height: 604px;
    }
  }
}

.cancle-icon {
  img {
    width: 20px;
    height: 20px;
  }
}

.download-icon {
  img {
    width: 20px;
    height: 20px;
  }
}

/deep/.el-button--mini {
  &.gps-play-btn {
    font-size: 12px;
    padding: 7px 12px;

    img {
      width: 10px;
      height: 11px;
    }
  }
}

.page-container {
  position: absolute;
  top: 0px;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: auto;
  background-color: #EEF5FE;

  .search-container {
    margin: 20px 10px 5px 20px;
    width: calc(100% - 40px);
  }

  .focus-container {
    position: absolute;
    top: 70px; /* no */
    left: 10px;
    right: 10px;
    bottom: 10px;
    display: flex;
    justify-content: space-around;

    .li-container {
      height: 99%;
      width: 32.5%;
      position: relative;
      background: #FFFFFF;
      box-shadow: 0px 2px 6px 0px rgba(0, 54, 103, 0.1);
      border-radius: 4px;

      .tags-list {
        position: relative;

        .tags {
          position: absolute;
          top: 1px;
          right: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1;

          .tag {
            margin-right: 5px;
            padding: 3px 5px;
            background: #fff;
            color: #222;
            border: 1px solid #00a0e9;
            border-radius: 4px;
            font-size: 12px;
          }
        }
      }

      .li-title {
        background-image: url('~@/icon/focus/head.png');
        background-size: 100% 100%;
        height: 46px;
        line-height: 46px;
        padding-left: 64px;
        color: #0E65DD;
        font-weight: bold;
        font-size: 20px;
      }

      .vedio-pagination {
        position: absolute;
        left: 3px;
        right: 3px;
        bottom: 0;
        height: 35px;

        /deep/.el-pagination {
          margin-top: 0;
          margin-bottom: 0;
        }
      }

      .preview {
        position: relative;

        .preview_img {
          position: absolute;
          top: 0;
          left: 50%;
          transform: translate(-50%, 0);
        }
      }

      .el-icon-edit {
        color: #0E65DD;
        cursor: pointer;
      }

      .no-tips {
        color: #999999;
      }

      .vedio-label {
        height: 40px;
        font-weight: normal;
        font-size: 15px;
        color: #222;
        line-height: 20px;
        margin: 10px 5px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;

        .tooltip {
          width: 200px;
        }
      }

      .vedio-box {
        position: absolute;
        top: 50px;
        left: 3px;
        right: 3px;
        bottom: 35px;
        padding: 0 15px;
        box-sizing: border-box;
        overflow-y: auto;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        align-content: flex-start;
        #focusAmplifyVideo{
          width: 100%;
          height: 375px;
        }

        .vedio-li {
          margin-bottom: 10px;
          width: 48%;
          min-height: 200px;

          .vedio-show {
            position: relative;
            height: 170px;
            border: 1px solid #00A0E9;
            border-radius: 4px;
            overflow: hidden;

            .played {
              position: absolute;
              top: 1px;
              left: 1px;
              color: var(--tree-black);
              background: var(--new-tab-bg);
              width: fit-content;
              height: 16px;
              border-radius: 4px;
              font-size: 12px;
              padding: 5px;
              z-index: 9;
            }

            &:hover {
              .cancle-icon {
                opacity: 1;
              }

              .download-icon {
                opacity: 1;
              }
            }

            .cancle-icon {
              position: absolute;
              top: 4px;
              right: 28px;
              cursor: pointer;
              font-size: 16px;
              opacity: 0;
            }

            .download-icon {
              position: absolute;
              top: 4px;
              right: 5px;
              cursor: pointer;
              font-size: 16px;
              opacity: 0;
            }

            .play-icon {
              position: absolute;
              top: 50%;
              left: 50%;
              width: 41px;
              height: 41px;
              transform: translate(-50%, -50%);
            }

            .vedio-time {
              position: absolute;
              bottom: 0px;
              width: 100%;
              left: 0;
              height: 30px;
              line-height: 30px;
              padding-left: 10px;
              font-size: 13px;
              background-color: rgba(0, 0, 0, 0.5);
              color: #fff;
              font-weight: normal;
              box-sizing: border-box;
            }
          }
        }
      }

      .gps-box {
        position: absolute;
        top: 50px;
        left: 0;
        right: 0;
        bottom: 35px;
        overflow-y: auto;

        ul {
          padding: 0 10px;

          li {
            padding: 10px 0 12px;
            border-bottom: 1px solid #DBE3ED;

            .gps-li {
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 100%;
              box-sizing: border-box;
              padding: 0 5px;

              &:hover {
                .cancle-icon {
                  display: block;
                }
              }

              .cancle-icon {
                color: #00deff;
                cursor: pointer;
                font-size: 16px;
                float: right;
                display: none;
                padding-right: 14px;
              }

              .gps-icon {
                width: 60px;
                height: 60px;

                img {
                  width: 60px;
                  height: 60px;
                }
              }

              .label-box {
                margin: 0 10px;
                align-self: flex-start;
                width: calc(100% - 200px);

                h5 {
                  font-weight: normal;
                  font-size: 15px;
                  color: #0E65DD;
                }

                .time-label {
                  font-size: 14px;
                }

                p {
                  width: 100%;
                  font-weight: normal;
                  color: #222;
                  font-size: 15px;
                  padding: 5px 0;
                }

                .description {
                  width: 100%;
                  display: inline-block;
                  word-break: normal;
                  word-wrap: break-word;
                  overflow: hidden;
                }
              }

              .gps-btn {
                width: 110px;
              }
            }
          }
        }
      }
    }
  }
}

.vedio-box::-webkit-scrollbar {
  display: block;
}

.gps-box::-webkit-scrollbar {
  // width: 0
  display: block;
}

.pic {
  width: 100%;
  height: 100%;
  cursor: pointer;
}

/deep/.analy {
  .el-input__inner {
    padding: 12px 20px 12px 30px !important;
  }
}

// 深色样式
.theme-dark {
  .page-container {
    background-color: #001143;

    .li-container {
      background: rgba(#002A96, 0.8);

      .li-title {
        background-image: url('~@/icon/focus/ic_headimg.png');
        color: #00E4FF;
      }

      .el-icon-edit {
        color: #00deff;
      }

      .no-tips {
        color: rgba(255, 255, 255, 0.5);
      }

      .vedio-label {
        color: #fff;
      }

      .gps-box {
        ul {
          li {
            border-bottom: 1px solid #2A5CBA;

            .gps-li {
              .label-box {
                h5 {
                  color: #00DEFF;
                }

                p {
                  color: #ffffff;
                }
              }
            }
          }
        }
      }
    }
  }

  .important-img {
    .img-title {
      color: #fff;
      border: 1px solid #00DEFF;

      .name {
        color: #fff;
      }
    }
  }
}

.search .el-form .el-form-item:last-child {
  margin-top: 0 !important;
}
</style>
<style lang="stylus" rel="stylesheet/stylus">
.el-tooltip__popper {
  max-width: 320px;
  line-height: 180%;
}
</style>
